export default __webpack_public_path__ + "static/media/innovation-561388_1920.dece4720.jpg";